//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data() {
    return {

    }
  },
  computed: {
    currentPage () {
      return this.$route.query.pageNum ? Number(this.$route.query.pageNum) : 1
    },
    isEn () {
      return this.$i18n.locale === 'en'
    }
  }
}
